import {
  SET_SEARCH_RESULT,
  SET_LOADED_DATA,
  SET_SEARCHED_DATA,
  SET_RANDOM_CHART,
  SET_SEARCH,
  SET_BAR_CHART_DETAILS,
  SET_BAR_CHART_VALUES
} from "./types";

const reducer = (state = {}, actions) => {
  switch (actions.type) {
    case SET_SEARCH:
      return {
        ...state,
        search: actions.values,
      };

    case SET_SEARCH_RESULT:
      return {
        ...state,
        searchResult: actions.values,
      };

    case SET_SEARCHED_DATA:
      return {
        ...state,
        searchedData: actions.values,
      };

    case SET_LOADED_DATA:
      const loadData = state?.loadData ?? {};
      const { values, name } = actions.values;
      loadData[name] = values;
      return {
        ...state,
        loadData,
      };

    case SET_RANDOM_CHART:
      return {
        ...state,
        randomChart: actions.values,
      };

      case SET_BAR_CHART_DETAILS:
        return {
          ...state,
          barChart: actions.values,  //barChart  is this correct?
        };

    case SET_BAR_CHART_VALUES:
      return {
        ...state,
        barChart: actions.values,
      };
    default:
      return state;
  }
};

export default reducer;
